import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import AdminInfoDataService from "@/services/AdminInfoDataService";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("");
const alertState = ref("");
const menuTitle = ref("News Admin Maintenance");

const newsAdminList = reactive([]);

const errormessage = ref("");

const userId = ref("");
const deleteUserId = ref("");
const deleteDestCode = ref("");
const todayDate = ref("");

onMounted(() => {
  isLoading.value = true;
  getNewsAdmin();
  const today = new Date();
  todayDate.value = today.toISOString().split("T")[0];
});

onUpdated(() => {
  isLoading.value = false;
});

const getNewsAdmin = () => {
  newsAdminList.splice(0);
  const data = { destCode: store.getters.mainMenuCode };

  AdminInfoDataService.getNewsAdmin(data).then((response: ResponseData) => {
    for (let info of response.data) {
      newsAdminList.push(info);
    }
  });
};

const getDeleteUserId = (userId: any, destCode: any) => {
  deleteUserId.value = userId;
  deleteDestCode.value = destCode;
};

const onClickAddButton = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = {
    userId: userId.value,
    destCode: store.getters.mainMenuCode,
  };

  if (userId.value.trim() == "") {
    errormessage.value = "※Please enter user ID";
  } else {
    errormessage.value = "";
    AdminInfoDataService.addNewsAdmin(data)
      .then((response: ResponseData) => {
        alertMessage.value = response.data.message;
        alertState.value = "success";
        isLoading.value = false;
        getNewsAdmin();
      })
      .catch((error: ResponseData) => {
        errormessage.value = error.response.data.message;
      });
  }
  isLoading.value = false;
};

const onClickDeleteButton = (userId: any, destCode: any) => {
  document.getElementById("deleteCancel")?.click();
  alertMessage.value = "null";
  alertState.value = "neutral";
  const data = { userId: userId, destCode: destCode };

  AdminInfoDataService.deleteNewsAdmin(data).then((response: ResponseData) => {
    alertMessage.value = response.data.message;
    alertState.value = "success";
    isLoading.value = false;
    getNewsAdmin();
  });

  isLoading.value = false;
};

const __returned__ = { isLoading, alertMessage, alertState, menuTitle, newsAdminList, errormessage, userId, deleteUserId, deleteDestCode, todayDate, getNewsAdmin, getDeleteUserId, onClickAddButton, onClickDeleteButton, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})